import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { useViewerHasAtLeastCustomerSupportRights } from "@/lib/rights/use-viewer-has-right";
import ReturnsDataTable from "@/pages/(app)/returns/list/components/returns-data-table/returns-data-table";
import useTranslation from "@babackapp/translations/use-translation";
import { Button } from "@babackapp/ui/components/button";
import { PlusIcon } from "@radix-ui/react-icons";
import { QuickFiltersBar } from "./components/quick-filters/quick-filters";

export default function ReturnsPage() {
  const t = useTranslation();
  const hasCustomerSupportRight = useViewerHasAtLeastCustomerSupportRights();
  const { data: shop } = useCurrentShopSuspense();

  return (
    <div className="w-full flex justify-center pt-16 px-4 min-w-0">
      <div className="w-full flex-1 flex flex-col gap-8 min-w-0">
        <div className={"flex flex-col flex-1 gap-8 min-w-0"}>
          <div className="flex justify-between items-center gap-2 w-full">
            <div>
              <h3 className="text-lg leading-6 font-medium text-gray-900">
                {t("returns.title")}
              </h3>
              <p className="text-sm leading-relaxed text-muted-foreground max-w-[500px]">
                {t("returns.subtitle")}
              </p>
            </div>

            {hasCustomerSupportRight && (
              <Button
                size={"sm"}
                className={"flex-row items-center justify-center gap-2"}
                onClick={() => window.open(`/o?shop=${shop.shopifyUrl}`)}
              >
                <PlusIcon />
                {t("returns.createReturn")}
              </Button>
            )}
          </div>

          <QuickFiltersBar />
          <ReturnsDataTable />
        </div>
      </div>
    </div>
  );
}
